// HelpAssistant/useSegmentPanelObstruction.js
//
// React hook side of segmentPanelObstruction.js (see that file for the full
// BUG-wheel-view-e4bc4c / BUG-wheel-view-6ae0ed writeup). Returns true while
// a View-Wheel mobile segment panel is open, else false, so HelpAssistant can
// hide its FAB rather than silently sitting on top of the panel's content.

import { useEffect, useState } from "react";
import {
  SEGMENT_PANEL_OPEN_ATTR,
  readSegmentPanelOpen,
} from "./segmentPanelObstruction";

export default function useSegmentPanelObstruction() {
  const [open, setOpen] = useState(readSegmentPanelOpen);

  useEffect(() => {
    const measure = () =>
      setOpen((prev) => {
        const next = readSegmentPanelOpen();
        return next === prev ? prev : next;
      });
    measure();
    const observer =
      typeof MutationObserver !== "undefined" ? new MutationObserver(measure) : null;
    if (observer && document.body) {
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: [SEGMENT_PANEL_OPEN_ATTR],
      });
    }
    return () => observer && observer.disconnect();
  }, []);

  return open;
}
